import { Tab, TabsComponent } from '@components';
import { Box, CollapsibleCard } from '@atgfr8/atg-ui-tailwind';
import { useParams } from '@solidjs/router';
import {
  CustomerGeneralDocuments,
  fetchCustomerDetailsDocuments,
} from '@store/customers/customerDetails';
import { Component, createEffect, createSignal } from 'solid-js';

import { CustomerDocumentUploader } from './CustomerDocumentUploader';

export const CustomerGeneralUploadDocuments: Component = () => {
  const [activeTab, setActiveTab] = createSignal(0);
  const [documents, setDocuments] = createSignal<CustomerGeneralDocuments[]>(
    [],
  );

  const params = useParams();

  createEffect(async () => {
    setDocuments([]);
    const res = await fetchCustomerDetailsDocuments(params.id as string);
    if (res && res.isSuccess) {
      setDocuments(res.value);
    }
  });

  const activeTabType = () => {
    switch (activeTab()) {
      case 0:
        return 'Public';
      case 1:
        return 'Confidential';
      case 2:
        return 'Misc';
      case 3:
        return 'Logo';
      default:
        return 'Public';
    }
  };

  return (
    <CollapsibleCard startTitle="Upload Documents" class="mb-2">
      <TabsComponent
        onTabClick={(i) => {
          setActiveTab(i);
        }}
        activeTab={activeTab()}
        tabs={['Public', 'Confidential', 'Misc', 'Logo'].map((item) => (
          <Tab>{item}</Tab>
        ))}
      />
      <Box p={1}>
        <CustomerDocumentUploader
          documents={documents}
          setDocuments={setDocuments}
          type={activeTabType()}
        />
      </Box>
    </CollapsibleCard>
  );
};
